import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { initAnalytics } from "@/lib/analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Capabilities from "@/pages/Capabilities";
import CaseStudies from "@/pages/CaseStudies";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";

// Marketing pages load eagerly (they are prerendered at build time and hydrated). Only the admin area is code-split.
const Login = lazy(() => import("@/pages/Login"));
const Admin = lazy(() => import("@/pages/Admin"));

const Fallback = <div className="min-h-[60vh] bg-paper" aria-busy="true" />;

// Route tree shared by the browser app and the build-time prerenderer (scripts/prerender.mjs).
export function AppRoutes() {
  return (
    <AuthProvider>
      <Suspense fallback={Fallback}>
        <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
            </Route>
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
